// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__HEpcA","error":"styles_error__1qVBc"};